export default __webpack_public_path__ + "static/media/01.d43754e0.jpg";